<template>
  <div>
    <div class="columns is-gapless is-vcentered is-border-top is-border-bottom has-background-light is-minH50p is-marginless">
      <div class="column is-padding-left"></div>
      <div class="column is-narrow is-border-left is-self-stretched">
        <a
          @click="createRdv"
          class="button is-radiusless is-small is-primary is-minH100 is-uppercase">
          <span class="icon"><i class="fas fa-calendar-plus"></i></span>
          <span>Nouveau Rendez-vous</span>
        </a>
      </div>
    </div>
    <div>
      <div
        class="column is-paddingless is-12 has-background-white"
        v-if="rdvList && rdvList.length">
        <div
          v-for="(e, idx) in rdvList"
          :key="e.event.pk">
          <div
            v-if="e && e.event && e.showDayLabel"
            class="column has-background-light is-size-5 has-text-centered is-padding-small"
            :class="{'is-border-top' : idx !== 0}">
            <router-link
              tag="a"
              :to="{name: 'CalendarDay', params: { year: e.year, month: e.month, day: e.day, panel: 'rdvs' }}">
              <strong>{{ e.date | dtFormat('dddd') | cap }} {{ e.date | dtFormat('DD') }} {{ e.date | dtFormat('MMMM') | cap }}</strong>
            </router-link>
          </div>
          <div
            v-if="e && e.event"
            class="bulmaCalendar">
            <div class="datetimepicker is-active is-fullwidth is-dayView is-cardless">
              <div class="datetimepicker-container">
                <div class="datepicker-body is-margin-bottom-small">
                  <calendar-rdv-items
                    :key="e.event.pk"
                    :event="e.event"
                    @loadRdv="loadRdv"
                    class="is-margin-left-xsmall is-margin-right-xsmall"></calendar-rdv-items>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-else
        class="is-padding">
        <span>Aucun rendez-vous à afficher</span>
      </div>
    </div>
  </div>
</template>

<script>
import ContactMixin from '../ContactMixin'
import moment from 'moment'
import { orderBy } from 'lodash'
import { bus, EVENTS } from '@/bus'

export default {
  name: 'ContactRdvs',
  components: {
    CalendarRdvItems: () => import('@/components/calendar/dayView/CalendarRdvItems')
  },
  mixins: [ContactMixin],
  computed: {
    rdvList () {
      let rdvList = []
      if (this.listedEvents && this.listedEvents.length) {
        return this.listedEvents.map(x => {
          let date = moment(x.date).format('DD/MM/YYYY')
          if (rdvList.includes(date) === false) {
            this.$set(x, 'showDayLabel', true)
            rdvList.push(date)
          }
          return x
        })
      } else {
        return []
      }
    },
    listedEvents () {
      let listedEvents = []
      if (this.sourceContactRdvs && Array.isArray(this.sourceContactRdvs) && this.sourceContactRdvs) {
        this.sourceContactRdvs.forEach(x => {
          let wrapper = {
            event: Object.assign({}, x),
            date: x.date,
            year: moment(x.date).format('YYYY'),
            month: moment(x.date).format('MM'),
            day: moment(x.date).format('DD'),
            showDayLabel: false
          }
          listedEvents.push(wrapper)
        })
      }
      return orderBy(listedEvents, x => {
        return moment(x.date)
      }, 'desc')
    }
  },
  watch: {
    sourceContactRdvs (v) {
      this.updateSources({ rdvs: v })
    }
  },
  created () {
    bus.$on(EVENTS.RDV_CREATED, (data) => {
      this.rdvCreatedFromQuickview(data.resource_pk)
    })
  },
  destroyed () {
    bus.$off([EVENTS.RDV_CREATED])
  },
  methods: {
    async rdvCreatedFromQuickview (pk) {
      let rdv = await this.getRdv(pk)
      if (rdv.contact.pk === this.contactPk) {
        this.getContactRdvs()
      }
    },
    async getRdv (pk) {
      try {
        let { data } = await this.$api.getOne(this.$resources.RDV, pk)
        return data
      } catch (err) {
        console.log(err)
      }
    },
    async loadRdv (pk) {
      try {
        let { data } = await this.$api.getOne(this.$resources.RDV, pk)
        let date = moment(data.date)
        let key = date.format('DD/MM/YYYY')
        this.$store.commit('addCalendarEvent', { event: data, key: key, type: 'rdvs' })
        this.getContactRdvs()
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>
